<script>
import { mapState, mapActions } from 'vuex';
/* components */
import FullScreenOverlay from '@/components/FullScreenOverlay';
import Button from '@/components/Button';
/* import { findGame } from '@/scripts/utils/collection'; */

/* tools */
import { getGameImage } from '@/scripts/utils';

export default {
  name: 'ConnectGame',
  components: {
    FullScreenOverlay,
    Button,
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapState(['user', 'games']),
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions({}),
    setType(id) {
      this.$emit('change', id);
    },
    getGameImage,
  },
};
</script>

<template>
  <FullScreenOverlay>
    <div class="onboarding">
      <div class="onboarding__top">
        <Button
          :to="$route.params.errorState ? '/settings' : null"
          :back="!$route.params.errorState"
          class="back"
        >
          <template #icon>
            <img :src="require(`@/assets/svg/arrow-left.svg`)" />
          </template>
        </Button>
      </div>
      <div class="onboarding__body">
        <!--  -->
        <div class="onboarding__row onboarding__row--head">
          <h1 class="onboarding__title">
            Connect A Game
          </h1>
          <div class="onboarding__text">
            Please select a game to connect your account and start getting
            rewarded.
          </div>
        </div>

        <!--  -->
        <div class="onboarding__row onboarding__row--list">
          <div class="list-btn">
            <!-- >map = games -->
            <div class="list-btn__item" v-for="game in games" :key="game.id">
              <div
                :class="{ 'btn-game': true, 'is-active': false }"
                :style="getGameImage(game, { style: true })"
                @click="setType(game.id)"
              ></div>
            </div>
            <!-- < -->
          </div>
        </div>
        <div class="onboarding__row onboarding__row--link">
          <Button to="/dashboard" class="link-white">
            Connect Accounts Later
          </Button>
        </div>
      </div>
    </div>
  </FullScreenOverlay>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.onboarding {
  &__title {
    font-family: Sen-Bold;
    font-size: 36px;
    line-height: 43px;
    text-transform: uppercase;
    color: #ffc800;
    text-align: center;
    margin: 0;

    & + .onboarding__text {
      margin-top: 15px;
    }
  }

  &__top {
    margin-bottom: 12px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
  }

  &__body {
    display: flex;
    flex-direction: column;
    width: 100%;
    flex-grow: 1;
  }

  &__text {
    font-family: Poppins-Light;
    font-size: 18px;
    line-height: 27px;
    color: rgba(255, 255, 255, 0.8);
    text-align: center;
  }

  &__row {
    & + &--list {
      margin-top: 70px;
    }

    & + &--link {
      margin-top: 70px;
      display: flex;
      justify-content: center;
    }
  }
}

.list-btn {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-left: -30px;
  margin-top: -30px;

  &__item {
    width: 100%;
    max-width: 170px;
    margin-left: 30px;
    margin-top: 30px;
  }
}

.btn-game {
  width: 100%;
  max-width: 170px;
  height: 170px;
  border-radius: 12px;
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: all 0.2s;
  cursor: pointer;

  &:after {
    content: '';
    display: block;
    position: absolute;
    width: calc(100% + 2px);
    height: calc(100% + 2px);
    border-radius: 12px;
    top: -1px;
    left: -1px;
    transition: all 0.2s;
    -webkit-filter: blur(1px);
    filter: blur(1px);
    border-style: solid;
    border-width: 1px;
    border-image-source: linear-gradient(
      to left,
      rgba(56, 213, 184, 0) 114%,
      #38d5b8 56%,
      rgba(56, 213, 184, 0) -10%
    );
    border-image-slice: 1;
    background-image: linear-gradient(
        to bottom,
        rgba(56, 213, 184, 0.1),
        rgba(56, 213, 184, 0.1)
      ),
      linear-gradient(
        to left,
        rgba(56, 213, 184, 0) 114%,
        #38d5b8 56%,
        rgba(56, 213, 184, 0) -10%
      );
    background-origin: border-box;
    background-clip: content-box, border-box;
    opacity: 0;
    visibility: hidden;
  }

  &:hover {
    border: 1px solid rgba(47, 155, 137, 0.2);
    &:after {
      opacity: 1;
      visibility: visible;
    }
  }

  &.is-active {
    border: 1px solid rgba(47, 155, 137, 0.2);

    &:before,
    &:after {
      opacity: 1;
      visibility: visible;
    }
  }

  &:before {
    content: '';
    border-bottom: 2px solid #38d5b8;
    border-left: 2px solid #38d5b8;
    width: 8px;
    height: 5px;
    position: absolute;
    transform: rotate(-45deg);
    top: 17px;
    right: 16px;
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s;
  }
}

@media (max-width: $mobile) {
  .onboarding {
    &__top {
      min-height: 29px;
      margin-bottom: 30px;
    }

    &__title {
      font-size: 24px;
      line-height: 29px;

      & + .onboarding__text {
        margin-top: 23px;
      }
    }

    &__text {
      font-size: 14px;
      line-height: 1.93;
      color: #ffffff;
    }

    &__row {
      & + &--list {
        margin-top: 30px;
        display: flex;
        justify-content: center;
        width: 100%;
      }

      & + &--link {
        margin-top: 40px;
      }
    }
  }

  .list-btn {
    margin-left: -10px;
    margin-top: -10px;
    width: auto;

    &__item {
      width: 140px;
      margin-left: 10px;
      margin-top: 10px;
    }
  }

  .btn-game {
    width: 140px;
    height: 140px;
  }
}
</style>
